import React, { FC, useRef, useState } from 'react'
import { fetchExcelAsyncResult, fetchExcelFile } from '@/pages/rule/utils/api'
import { downloadFile } from '@/common/utils'
import LoadingIcon from '@/components/LoadingIcon'
import { excelPolling } from '@/common/utils/polling'

export enum DownloadTemplateTypeEnum {
  /** 导入模板 */
  IMPORT_TEMP = 1001,
  /** 额度下载 */
  AMOUNT_REST = 1003,
  /** 余额更新模板 */
  BALANCE_UPDATE_TEMP = 1004,
}

type DownloadLinkProps = {
  templateType: DownloadTemplateTypeEnum
  rulePackId?: string
}

const DownloadLink: FC<React.PropsWithChildren<DownloadLinkProps>> = (props) => {
  const  {
    templateType,
    rulePackId,
  } = props
  const [isLoading, setIsLoading] = useState(false)
  const excelTimeoutRef = useRef(0)

  const handleDownload = async () => {
    if (isLoading) return
    try {
      setIsLoading(true)
      const data = await fetchExcelFile({ type: templateType, rulePackageId: rulePackId })
      const { fileURL = '', taskToken = '' } = data || {}
      if (fileURL) {
        setIsLoading(false)
        downloadFile({ url: fileURL })
      } else if (taskToken) {
        excelPolling({
          requestFunction: async () => fetchExcelAsyncResult(data.taskToken as string),
          onTimeoutChange: (timeout) => {
            excelTimeoutRef.current = timeout
          },
          onFinish: (param) => {
            const { fileUrl } = param.data || {}
            setIsLoading(false)
            if (fileUrl) {
              downloadFile({ url: fileUrl })
            }
          },
        })
      }
    } catch (error) {
      setIsLoading(false)
      console.log(error)
    }
  }


  return (
    <div onClick={handleDownload} style={{ display: 'flex', alignItems: 'center', color: '#FF5500', cursor: 'pointer' }}>
      {props.children}&ensp;&ensp;
      {isLoading && (<LoadingIcon />)}
    </div>
  )
}

export default DownloadLink
